import React from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox
} from "@mui/material";

export interface CheckboxOption {
  label: string;
  value: any;
  disabled?: boolean;
  required?: boolean;
}

interface KeydriveCheckboxGroupProps {
  options: CheckboxOption[];
  selectedValues: any[];
  onChange: (selected: any[]) => void;
}

export const KeydriveCheckboxGroup: React.FC<KeydriveCheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange
}) => {
  const handleChange = (value: string) => {
    if (selectedValues?.includes(value)) {
      onChange(selectedValues?.filter((v) => v !== value) || []);
    } else {
      onChange([...(selectedValues || []), value]);
    }
  };

  return (
    <FormGroup>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={selectedValues?.includes(option.value)}
              onChange={() => handleChange(option.value)}
            />
          }
          label={option.label}
          disabled={option.disabled}
          required={option.required}
        />
      ))}
    </FormGroup>
  );
};